import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Header from "../components/header";
import { useNavigate } from "react-router-dom";

// import { mapboxgl } from "mapbox-gl";
import ReactMapGL, { Marker, Popup } from "react-map-gl";
import "./pstyle.css";
// import { Marker } from 'mapbox-gl';
import { socket } from "../../src/socket";

import { useSelector } from "react-redux";
import translations from "../locals/translation";

import Swal from "sweetalert2";
import { LuCircleChevronLeft } from "react-icons/lu";
// import { IoIosSearch } from "react-icons/io";
import { performVerification } from "../commonFunc/verification";

function VendorLocation() {
  const navigate = useNavigate();
  const language = useSelector((state) => state.language.value);
  const [popupInfo, setPopupInfo] = useState(null);
  const [showPopUp, setShowPopUp] = useState(false);
  const [popupExit, setPopupExit] = useState(false);

  const [truckCoordinates, setTruckCoordinates] = useState([
    { lat: 40.7128, lng: 74.006 }, // New York City
    { lat: 34.0522, lng: 118.2437 }, // Los Angeles
    { lat: 51.5074, lng: 0.1278 }, // London
    { lat: 48.8566, lng: 2.3522 }, // Paris
    // Add more coordinates as needed
  ]);
  const [userCoordinates, setUserCoordinates] = useState([
    { lat: 40.7128, lng: 74.006 }, // New York City
    { lat: 34.0522, lng: 118.2437 }, // Los Angeles
    { lat: 51.5074, lng: 0.1278 }, // London
    { lat: 48.8566, lng: 2.3522 }, // Paris
    // Add more coordinates as needed
  ]);
  const [viewport, setViewport] = useState({
    latitude: 39.8283, // Center of continental US
    longitude: -98.5795,
    zoom: 4,
  });
  const t = (key) => {
    if (translations[language]) {
      const translation = translations[language][key];
      return translation !== undefined ? translation : key;
    } else {
      return key;
    }
  };

  const [runUE, setRunUE] = useState(false);
  const [runnUE3, setRunnUE3] = useState(false);

  ReactMapGL.accessToken =
    "pk.eyJ1IjoiYXNoYXlhdCIsImEiOiJjbHRyMmh4YmowYTJjMmtxbWgzZTd2a2JiIn0.TP0CZqeXTnQsaJXlBdRHrA";

  const TOKEN =
    "pk.eyJ1IjoiYXNoYXlhdCIsImEiOiJjbHRyMmh4YmowYTJjMmtxbWgzZTd2a2JiIn0.TP0CZqeXTnQsaJXlBdRHrA";

  const Data = {
    endPoint: "/getAllUsers",
    responseType: "user", // Added property to specify the type of response
    token: localStorage.getItem("token"),
  };
  const Data2 = {
    endPoint: "/getAllTrucks",
    responseType: "truck", // Added property to specify the type of response
    token: localStorage.getItem("token"),
  };
  function isValidNumber(data) {
    // Check if data is a string
    if (typeof data !== "string") {
      return false;
    }

    // Check if data can be converted to a valid number
    const number = Number(data);
    if (isNaN(number)) {
      return false;
    }

    // Check if data contains more than one dot
    const dotCount = data.split(".").length - 1;
    if (dotCount > 1) {
      return false;
    }

    // If all checks pass, data is a valid number
    return true;
  }

  useEffect(() => {
    if (!performVerification()) {
      Swal.fire({ text: t("Login first"), icon: "warning" });
      navigate("/login");
    }
    socket.connect();
    socket.emit("API", JSON.stringify(Data));
    socket.emit("API", JSON.stringify(Data2));
    socket.on("APIResponse", (message) => {
      const parsedMessage = JSON.parse(message);

      if (parsedMessage.message === "Trucks Fetched Successfully") {
        const correctTruckData = parsedMessage.truckData.filter(
          (item) =>
            isValidNumber(item.lat) === true &&
            isValidNumber(item.long) === true
        );
        // filter details of item.lat is enpty or null or undefined

        const filteredArray = correctTruckData.filter((item) => {
          // Filter out items where lat or long is undefined, null, or empty string
          return (
            item.lat !== undefined &&
            item.long !== undefined &&
            item.lat !== null &&
            item.long !== null &&
            item.lat !== "" &&
            item.long !== ""
          );
        });

        // eslint-disable-next-line array-callback-return
        const filteredData = filteredArray
          // eslint-disable-next-line array-callback-return
          .map((item, index) => {
            console.log('item:2234 ', item);
            if (item.lat && item.long) {
              return {
                id: item.truck_id,
                lat: Number(item.lat),
                lng: Number(item.long),
                truck_name: item.truck_name,
                username: item.username,
                vendor_username: item.vendor_username,
                vendors_name: item.first_name,
                vendors_phone: item.phone,
                vendors_email: item.email
              };
            }
            // or any other appropriate action if lat and long are not present
          })
          .filter((item) => item !== null); // filtering out null values if any

        setTruckCoordinates(filteredData);
        setRunUE(!runUE);
        setRunnUE3(!runnUE3);
      } else {
        const correctUserData = parsedMessage.userData.filter(
          (item) =>
            isValidNumber(item.lat) === true &&
            isValidNumber(item.long) === true
        );

        const filteredArray = correctUserData.filter((item) => {
          // Filter out items where lat or long is undefined, null, or empty string
          return (
            item.lat !== undefined &&
            item.long !== undefined &&
            item.lat !== null &&
            item.long !== null &&
            item.lat !== "" &&
            item.long !== ""
          );
        });

        let mappedData5 = filteredArray.map((item5, index) => {
          return {
            id: index + 1,
            lng: Number(item5?.long),
            lat: Number(item5?.lat),
            icon: "./img/user.png",
          };
        });
        setUserCoordinates(mappedData5);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <Header />

      <div className="login-heading">
        <div className="search-backheading">
          <div className="svg-location">
            <LuCircleChevronLeft
              fill="none"
              className="back-button"
              onClick={() => navigate("/dashboard")}
            />
          </div>
          <div className="heading-sbhaed">

            <h1 style={{ marginTop: "65px" }}>{t("Vendors Locations")}</h1>
            <h5>{t("Live Locations of the Vendors and the users")}</h5>
          </div>
        </div>
        <div className="map-container">
          <ReactMapGL
            mapboxAccessToken={TOKEN}
            initialViewState={viewport}
            onViewportChange={(viewport) => setViewport(viewport)}
            mapStyle="mapbox://styles/mapbox/streets-v12"
            transitionDuration="200"
            attributionControl={true}
          >
            {truckCoordinates.map((coordinate, index) => (
              <Marker
                key={index}
                latitude={coordinate.lat}
                longitude={coordinate.lng}
                onClick={() => {
                  setPopupInfo(coordinate);
                  setShowPopUp(true);
                }}
                icon="./img/truck.svg"
              >
                <img
                  src="./img/truck.svg"
                  style={{ width: "45px", height: "45px" }}
                  alt="marker"
                />
              </Marker>
            ))}

            {userCoordinates.map((coordinate, index) => (
              <Marker
                key={index}
                latitude={coordinate.lat}
                longitude={coordinate.lng}
                icon="./img/truck.svg"
              >
                <img
                  src="./img/user.png"
                  style={{ width: "21px", height: "28px" }}
                  alt="marker"
                />
              </Marker>
            ))}

            {showPopUp && (
              <Popup
                latitude={popupInfo.lat}
                longitude={popupInfo.lng}
                onClose={() => {
                  setPopupExit(true);
                  setTimeout(() => {
                    setPopupInfo(null);
                    setShowPopUp(false);
                    setPopupExit(false);
                  }, 400); // match exit animation duration
                }}
                closeOnClick={false}
                closeOnClickOutside={false}
              >
                <div className={popupExit ? 'popup-exit' : ''}>
                  <p className="heading">{t("Truck Information")}</p>
                  <p><span className="label">{t("Truck Name")}:</span> {popupInfo.truck_name || "-"}</p>
                  <p><span className="label">{t("Vendors Name")}:</span> {popupInfo.vendors_name || "-"}</p>
                  <p><span className="label">{t("Vendor Username")}:</span> {popupInfo.vendor_username || "-"}</p>
                  <p><span className="label">{t("Vendor Ph.")}:</span> {popupInfo.vendors_phone || "-"}</p>
                  <p><span className="label">{t("Vendor Email")}:</span> {popupInfo.vendors_email || "-"}</p>
                </div>
              </Popup>
            )}
          </ReactMapGL>
        </div>
      </div>
    </React.Fragment>
  );
}

export default VendorLocation;
